import { ConfigProviderProps } from 'antd/lib/config-provider';

const enableVirtualScrollItemsCount = 500;

const ANTD_CONFIG: ConfigProviderProps = {
  // Disable virtual list by default ->
  // -> scroll is not smooth for small amount of items in the list
  // Enable virtual list only for performance reasons
  virtual: false,
};

export { ANTD_CONFIG, enableVirtualScrollItemsCount };
